import { IS_DEMO_MODE } from '@/utils/demoMode';
import { EmployeeListComponent } from './EmployeeList.component';
import { EmployeeListDemoComponent } from './EmployeeList.demo.component';

export const EmployeeListPage = IS_DEMO_MODE
  ? EmployeeListDemoComponent
  : EmployeeListComponent;
